import { render, staticRenderFns } from "./teshugangwei.vue?vue&type=template&id=33d90294&scoped=true&"
import script from "./teshugangwei.vue?vue&type=script&lang=js&"
export * from "./teshugangwei.vue?vue&type=script&lang=js&"
import style0 from "./teshugangwei.vue?vue&type=style&index=0&id=33d90294&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d90294",
  null
  
)

export default component.exports